module.exports = __webpack_public_path__ + "img/disabled_delete.c47d52a4.svg";